import { useEffect } from "react";

const isTyping = (e) => {
  const t = e.target;
  const tag = t?.tagName;
  return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || t?.isContentEditable;
};

export function matchesHotkey(e, combo) {
  if (!combo) return false;
  const parts = combo.split("+").map((p) => p.trim().toLowerCase());
  const key = parts[parts.length - 1];
  const needCtrl = parts.includes("ctrl");
  const needShift = parts.includes("shift");
  const needAlt = parts.includes("alt");
  if (!!e.ctrlKey !== needCtrl && !(needCtrl && e.metaKey)) return false;
  if (!!e.shiftKey !== needShift) return false;
  if (!!e.altKey !== needAlt) return false;
  return e.key.toLowerCase() === key;
}

export function useHotkeys(hotkeys, handlers) {
  useEffect(() => {
    const onKey = (e) => {
      for (const [name, combo] of Object.entries(hotkeys || {})) {
        if (!handlers[name]) continue;
        if (!matchesHotkey(e, combo)) continue;
        const isFn = /^f\d{1,2}$/i.test(combo);
        if (!isFn && !combo.includes("+") && isTyping(e)) continue;
        e.preventDefault();
        handlers[name](e);
        return;
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [hotkeys, handlers]);
}
